module.exports = __webpack_public_path__ + "img/P2-A2.93865900.svg";